export default __webpack_public_path__ + "static/media/Crossbow of the Underworld.acaa4a5a.jpg";